import { FC, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import { getShareLinkCreator } from '@/core/apis/util-apis';
import { appendImageRepoDomainIfNotExistInUrl } from '@/core/utils/helpers';
import { appSettings } from '@/settings/app-settings';
import HighLights from '@/ux-legacy/experience/highlights/Highlights';
import { ImageGallery001, IMG_PLACEHOLDER } from '@/ux-legacy/uikit/components/components-index';

import ProductDetails from '../../ProductBolderAssetShopify/parts/ShopifyDetails';

type ProductAssetShopifyType = {
  data: any;
  shareId?: string;
  vendorConfig?: any;
  isPopupView?: boolean;
  highLights?: any[];
};

const ProductDigital: FC<ProductAssetShopifyType> = ({
  data,
  shareId,
  vendorConfig,
  isPopupView,
  highLights,
}) => {
  const [imageList, setImageList] = useState<string[]>([]);

  const [initialIndex, setInitialIndex] = useState<number>();

  const [showImageGallery, setShowImageGallery] = useState(false);

  const [linkCreatorDetails, setLinkCreatorDetails] = useState<any>();

  const imageUploadElement = useRef<any>(null);

  const getShareLinkCreatorDetails = (shareId: string) => {
    getShareLinkCreator(shareId)
      .then((res) => {
        setLinkCreatorDetails(res);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  useEffect(() => {
    if (data) {
      setImageList(data?.images || []);
    }
  }, [data]);

  useEffect(() => {
    if (shareId) {
      getShareLinkCreatorDetails(shareId);
    }
  }, [shareId]);

  return (
    <>
      <div className="w-full flex flex-col gap-y-2 md:p-2 p-1">
        {showImageGallery &&
          createPortal(
            <ImageGallery001
              isOpen={showImageGallery}
              imageList={[
                { image: data?.bannerImage },
                ...(data?.images || []).map((image: any) => {
                  return {
                    image,
                  };
                }),
              ]}
              initialIndex={initialIndex}
              callbackOnClose={() => setShowImageGallery(false)}
            />,
            document.body,
          )}

        {highLights && highLights?.length > 0 && (
          <div className="w-full flex mx-auto my-2">
            <HighLights highlights={highLights} showDelete={false} />
          </div>
        )}

        <div className={['listing-image relative group/image'].join(' ')}>
          <div className="flex flex-col md:flex-row overflow-hidden rounded-lg ">
            <button className="w-full flex flex-row " onClick={() => setShowImageGallery(true)}>
              <img
                alt="Bolder"
                className={['w-full h-[240px] md:h-[500px] object-cover bg-gray-100 shadow '].join(' ')}
                src={appendImageRepoDomainIfNotExistInUrl(data?.bannerImage) || IMG_PLACEHOLDER}
              />
            </button>

            <div className={`absolute top-0 left-0 mt-4 ml-4 opacity-0 group-hover/image:opacity-100`}>
              {imageList.length > 0 && (
                <button
                  className="bg-gray-300 px-4 py-2"
                  onClick={() => {
                    setShowImageGallery(true);
                  }}
                >
                  view all {imageList.length + 1} images
                </button>
              )}
            </div>
            {/* {imageList.length > 0 && (
            <ImageSlideView
              slideUrls={imageList}
              onImageClick={(index: any) => {
                setInitialIndex(index + 1);
                setShowImageGallery(true);
              }}
            />
          )} */}
          </div>
        </div>

        <div className="p-2 md:p-0">
          {linkCreatorDetails && (
            <div className="md:px-4">
              <div className="flex bg-slate-200 rounded-full px-2 pr-1 md:px-1 md:pr-2 md:py-1 w-fit font-bold text-xs md:text-base items-center">
                <img
                  alt={'user'}
                  className=" w-6 h-6 object-cover rounded-full mr-1"
                  src={appSettings.api.S3_MEDIA_COMPRESSED + linkCreatorDetails?.DisplayPic}
                />
                {linkCreatorDetails?.Name}&nbsp;<span className="text-slate-500">recommended the</span>
              </div>
            </div>
          )}
          <div className="font-bold text-[18px] md:text-[20px] text-[#323232] md:px-4 my-2">{data?.name}</div>
          <div className="text-[14px] md:text-[16px] text-[#323232] md:px-4 mt-2 line-clamp-[8] md:hidden">
            {data?.longDescription}
          </div>

          <ProductDetails
            itemData={data}
            assetManagerData={{ product: data }}
            selectedImage={data?.bannerImage}
            onImageChange={() => {}}
            imageUploadElement={imageUploadElement}
            key={`shopifyDetails_${data?._id}`}
            shareId={shareId}
            showCartButtonAlawys={true}
            vendorConfig={vendorConfig}
            isPopupView={isPopupView}
          />
        </div>
      </div>
    </>
  );
};

export default ProductDigital;
